import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["css", "asChild", "as", "style", "className", "options", "name", "onChange", "id", "disabled", "hasError", "isClearable", "hideDropdownIndicator", "isMulti", "value", "inputId", "openMenuOnClick", "renderOption", "valueRenderType", "inputValue", "menuPlacement", "menuPosition", "portalMenu", "onInputChange", "noOptionsMessage", "icon"];
import React, { useMemo } from "react";
import ReactSelect from "react-select";
import useGetCustomComponents from "../../hooks/useGetCustomComponents";
import useMenuPositionProps from "../../hooks/useMenuPositionProps";
import useTypeaheadChangeHandlers from "../../hooks/useTypeaheadChangeHandlers";
import { getSafeInputValue, getSafeValue } from "../../logic";
import { jsx as _jsx } from "react/jsx-runtime";
var SelectPrimitive = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var css = _ref.css,
    asChild = _ref.asChild,
    as = _ref.as,
    style = _ref.style,
    className = _ref.className,
    options = _ref.options,
    name = _ref.name,
    onChange = _ref.onChange,
    id = _ref.id,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    isClearable = _ref.isClearable,
    hideDropdownIndicator = _ref.hideDropdownIndicator,
    isMulti = _ref.isMulti,
    value = _ref.value,
    inputId = _ref.inputId,
    openMenuOnClick = _ref.openMenuOnClick,
    renderOption = _ref.renderOption,
    valueRenderType = _ref.valueRenderType,
    inputValue = _ref.inputValue,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? "auto" : _ref$menuPlacement,
    _ref$menuPosition = _ref.menuPosition,
    menuPosition = _ref$menuPosition === void 0 ? "absolute" : _ref$menuPosition,
    _ref$portalMenu = _ref.portalMenu,
    portalMenu = _ref$portalMenu === void 0 ? false : _ref$portalMenu,
    _ref$onInputChange = _ref.onInputChange,
    onInputChange = _ref$onInputChange === void 0 ? function () {
      return null;
    } : _ref$onInputChange,
    noOptionsMessage = _ref.noOptionsMessage,
    icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  var disabledOptions = function disabledOptions(option) {
    return option.disabled;
  };
  var _useGetCustomComponen = useGetCustomComponents({
      hideDropdownIndicator: hideDropdownIndicator,
      component: "select",
      valueRenderType: valueRenderType
    }),
    customComponents = _useGetCustomComponen.customComponents,
    styles = _useGetCustomComponen.styles;
  var safeValue = useMemo(function () {
    return getSafeValue(value, options, isMulti);
  }, [value, options, isMulti]);
  var safeInputValue = useMemo(function () {
    return getSafeInputValue(value, inputValue, valueRenderType);
  }, [value, inputValue, valueRenderType]);
  var _useTypeaheadChangeHa = useTypeaheadChangeHandlers(onChange, onInputChange, valueRenderType),
    _useTypeaheadChangeHa2 = _slicedToArray(_useTypeaheadChangeHa, 2),
    handleOnChange = _useTypeaheadChangeHa2[0],
    handleInputOnChange = _useTypeaheadChangeHa2[1];
  var menuPositionProps = useMenuPositionProps(menuPlacement, menuPosition, portalMenu);
  return /*#__PURE__*/_jsx(ReactSelect, _extends({
    id: id,
    inputId: inputId
    // does a check for value and if it exists, it will return the safeValue if it does other wise passes null to allow the component to function uncontrolled
    ,
    value: value && safeValue,
    openMenuOnClick: openMenuOnClick,
    name: name,
    onChange: handleOnChange,
    ref: forwardedRef,
    options: options,
    isDisabled: disabled,
    isOptionDisabled: disabledOptions,
    "aria-invalid": hasError,
    isClearable: isClearable,
    isMulti: isMulti,
    icon: icon,
    styles: styles,
    components: customComponents // inner components that have been customised
    ,
    renderOption: renderOption,
    unstyled: true,
    controlShouldRenderValue: valueRenderType !== "typeahead",
    inputValue: safeInputValue,
    onInputChange: handleInputOnChange,
    noOptionsMessage: noOptionsMessage || valueRenderType === "typeahead" ? function () {
      return "No suggestions";
    } : function () {
      return "No options";
    }
  }, menuPositionProps, props));
});
SelectPrimitive.displayName = "SelectPrimitive";
export default SelectPrimitive;